<script>
import accordionItem from '../components/AccordionItem.vue';
import fadeIn from '../components/animations/FadeIn.vue';
import linesUp from '../components/animations/LinesUp.vue';
import parallaxBg from '../components/ParallaxBg.vue';
import wordsUp from '../components/animations/WordsUp.vue';
import zoomIn from '../components/animations/ZoomIn.vue';

export default {
    components: {
        accordionItem,
        fadeIn,
        linesUp,
        parallaxBg,
        wordsUp,
        zoomIn
    },

    data() {
        return {
            activePanel: 0
        };
    }
};
</script>
